import { Field } from 'formik';
import type { FieldProps } from 'formik';

import { Checkbox } from '@frontend/components';

export type CheckboxFieldProps<FieldName extends string> = {
  name: FieldName;
  text: string;
};

export const CheckboxField = <
  FieldName extends string,
  FormData extends Record<string, unknown>,
>({
  name,
  text,
}: CheckboxFieldProps<FieldName>) => (
  <Field name={`${name}`}>
    {({ field, form }: FieldProps<FieldName, FormData>) => (
      <Checkbox
        isChecked={!!field.value}
        onChange={(e) => form.setFieldValue(field.name, e.target.checked)}
      >
        {text}
      </Checkbox>
    )}
  </Field>
);
